module.exports = __webpack_public_path__ + "img/btn_suppression2.74c38f57.svg";